import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/admin/Modal.css'; // Crearemos este archivo CSS

function Modal({ isOpen, onClose, title, children, closeOnOutsideClick = true }) {
  if (!isOpen) {
    return null;
  }

  const handleOverlayClick = (e) => {
    if (closeOnOutsideClick) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}> {/* Cierra al hacer clic fuera si closeOnOutsideClick es true */}
      <div className="modal-content" onClick={(e) => e.stopPropagation()}> {/* Evita cierre al hacer clic dentro */}
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close-btn" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
}

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  closeOnOutsideClick: PropTypes.bool
};

export default Modal; 